// extracted by mini-css-extract-plugin
export default {"container":"viewJob_container__-+SW2","content":"viewJob_content__m4+5w"};